import React, { useEffect, useState } from "react";
import GreyInfo from "../../../../../../../merchant/panel/scripts/shared/greyInfo/greyInfo.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import "./formatCountSelector.css";
export default function CountSelector(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { format } = props;
    const [count, setCount] = useState((_b = (_a = format.setDefaultCount) !== null && _a !== void 0 ? _a : format.minCount) !== null && _b !== void 0 ? _b : 0);
    useEffect(() => {
        props.onChange(count);
    }, [count]);
    if (format["@hidden"] === true)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "count-selector-container" },
        React.createElement("div", null, (_c = format.overridePrefix) !== null && _c !== void 0 ? _c : "Format",
            " ", (_e = (_d = props.format) === null || _d === void 0 ? void 0 : _d["@labelName"]) !== null && _e !== void 0 ? _e : props.formatName,
            format.type === "electronic-file" ? "" : " sztuk",
            ":",
            format.shortDescription && (React.createElement("div", null,
                React.createElement(GreyInfo, null, format.shortDescription)))),
        React.createElement("div", { className: "count-selector-inputs" },
            React.createElement(Button, { text: "-", classNames: ((_f = format.minCount) !== null && _f !== void 0 ? _f : 0) >= count ? "button-disabled" : "", onClick: () => count > 0 && setCount(count - 1), value: "count_decrement" }),
            React.createElement("span", { className: "count-span" }, count),
            React.createElement(Button, { text: "+", classNames: ((_g = format.maxCount) !== null && _g !== void 0 ? _g : Infinity) <= count ? "button-disabled" : "", onClick: () => setCount(count + 1), value: "count_increment" }),
            typeof format.defaultPrice === "number" &&
                (format.showPriceInOrderingView === true ||
                    format.showPriceInOrderingView === undefined) && (React.createElement(GreyInfo, null,
                format.defaultPrice,
                "z\u0142/szt")))));
}
